import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { SharedZoneBlocks, SharedZoneFullScreenBanner } from 'store/SharedZone/blocks/selectors';
import { IncludeContent, Image } from 'bricks';
import { Heading } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function BannerWrapper({ href, target, className, children, style }) {
  return href ?
      <a href={href} target={target} className={className} style={style}>
        {children}
      </a>
    : <div className={className} style={style}>
        {children}
      </div>;
}

BannerWrapper.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.object,
};

function FullScreenBannerBlockLayout({
  imageBackGround,
  url,
  openInNewTab,
  imageUrl,
  mobileImageUrl,
  markup,
  heading,
  headlineTagName,
  isMobile,
}) {
  return (
    <div className={cx('component')}>
      {heading ?
        <Heading tagName={headlineTagName} level={2} className={cx('headline')}>
          {heading}
        </Heading>
      : null}
      {mobileImageUrl && imageUrl ?
        <BannerWrapper
          className={cx('wrapper')}
          style={{ backgroundColor: imageBackGround }}
          href={url}
          target={openInNewTab ? '_blank' : '_self'}
        >
          <Image src={isMobile ? mobileImageUrl : imageUrl} className={cx('image')} alt="" />
        </BannerWrapper>
      : null}
      {markup ?
        <IncludeContent htmlContent={markup} />
      : null}
    </div>
  );
}

FullScreenBannerBlockLayout.propTypes = {
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  isMobile: PropTypes.bool,
  imageBackGround: PropTypes.string,
  url: PropTypes.string,
  openInNewTab: PropTypes.bool,
  imageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  markup: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow640(state),
  heading: SharedZoneBlocks.getHeadline(state),
  headlineTagName: SharedZoneBlocks.getHeadlineTagName(state),
  imageBackGround: SharedZoneFullScreenBanner.getImageBackGround(state),
  mobileImageUrl: SharedZoneFullScreenBanner.getMobileImageUrl(state),
  imageUrl: SharedZoneFullScreenBanner.getImageUrl(state),
  openInNewTab: SharedZoneFullScreenBanner.getOpenInNewTab(state),
  markup: SharedZoneFullScreenBanner.getMarkup(state),
  url: SharedZoneFullScreenBanner.getUrl(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(FullScreenBannerBlockLayout);
